//This is the white bar that goes the width of the screen
import React, { useState, useEffect } from 'react'
import Card from './Card'
import './SelectLeague.css'
import { useNavigate } from 'react-router-dom'
//import LeagueDatabaseTable from '../LeagueDatabaseTable'

const SelectLeagueSchedule = () => {
	console.log('inside SelectLeagueSchedule.js')

	const [isLoading, setIsLoading] = useState(false)
	const [loadedLeagues, setLoadedLeagues] = useState()
	const [leaguesNoDuplicates, setLeaguesNoDuplicates] = useState()
	const [dropdownTournaments, setDropdownTournaments] = useState()
	const [error, setError] = useState()
	let selectedLeague

	//Call backend to get all the current leagues for our dropdown
	useEffect(() => {
		const sendRequest = async () => {
			setIsLoading(true)
			try {
				const response = await fetch(
					process.env.REACT_APP_BACKEND_URL + '/admin/leagues/current',
				)

				const responseData = await response.json()

				if (!response.ok) {
					throw new Error(responseData.message)
				}

				setLoadedLeagues(responseData.currentLeagues)
				setLeaguesNoDuplicates(responseData.currentLeaguesSortedNoDuplicates)
				setDropdownTournaments(responseData.dropdownTournaments)
				setIsLoading(false)
			} catch (err) {
				setError(err.message)
			}
			setIsLoading(false)
		}
		sendRequest()
	}, [setLoadedLeagues, setLeaguesNoDuplicates])

	let leaguesNoDuplicatesArray, dropdownTournamentsArray, combinedArray

	//
	// build internal league list
	//
	if (leaguesNoDuplicates && !isLoading) {
		leaguesNoDuplicatesArray = []
		leaguesNoDuplicates.forEach((league) => {
			const leagueDisplay = league.leagueName
			leaguesNoDuplicatesArray.push(leagueDisplay)
		})
	}

	//
	// build external tournament list
	//
	if (dropdownTournaments && !isLoading) {
		dropdownTournamentsArray = []
		dropdownTournaments.forEach((tournament) => {
			const tournamentDisplay = tournament.tournamentName
			dropdownTournamentsArray.push(tournamentDisplay)
		})
	}

	//
	// combine them for a single dropdown
	//
	if (!isLoading) {
		combinedArray = []
		leaguesNoDuplicatesArray &&
			leaguesNoDuplicatesArray.forEach((name) => combinedArray.push(name))

		dropdownTournamentsArray &&
			dropdownTournamentsArray.forEach((name) => combinedArray.push(name))
	}

	let navigate = useNavigate()

	const handleChange = (e) => {
		if (e.target.value === '*Previous Tournaments*') {
			navigate('/league/previousLeagues')
		} else if (e.target.value !== 'Select League or Tournament....') {
			e.preventDefault()
			const selectedValue = e.target.value

			//
			// If user picked an INTERNAL league (first chunk)
			//
			if (leaguesNoDuplicates && selectedValue < leaguesNoDuplicates.length) {
				selectedLeague = leaguesNoDuplicates[selectedValue]
				const leagueId = selectedLeague._id
				navigate(`/league/schedule/${leagueId}`)
				return
			}

			//
			// Otherwise user picked an EXTERNAL tournament (second chunk)
			//
			if (dropdownTournaments) {
				const externalIndex = selectedValue - (leaguesNoDuplicates?.length || 0)
				const selectedTournament = dropdownTournaments[externalIndex]

				if (selectedTournament && selectedTournament.tournamentLink) {
					window.open(
						selectedTournament.tournamentLink,
						'_blank',
						'noopener,noreferrer',
					)
				}
			}
		}
	}

	return (
		<React.Fragment>
			<Card>
				{!isLoading && combinedArray && (
					<form className='form-control-lg'>
						<select
							className='selector my-1 mr-sm-2 selectLeagueDropdown'
							onChange={handleChange}
						>
							<option defaultValue>Select League or Tournament....</option>

							{combinedArray.map((item, i) => (
								<option value={i} key={i}>
									{item}
								</option>
							))}

							<option style={{ background: '#edcb37' }}>
								*Previous Tournaments*
							</option>
						</select>
					</form>
				)}
			</Card>
		</React.Fragment>
	)
}

export default SelectLeagueSchedule

/* //This is the white bar that goes the width of the screen
import React, { useState, useEffect } from 'react'
import Card from './Card'
import './SelectLeague.css'
import { useNavigate } from 'react-router-dom'
//import LeagueDatabaseTable from '../LeagueDatabaseTable'

const SelectLeagueSchedule = () => {
	const [isLoading, setIsLoading] = useState(false)
	const [loadedLeagues, setLoadedLeagues] = useState()
	const [leaguesNoDuplicates, setLeaguesNoDuplicates] = useState()
	const [error, setError] = useState()
	let selectedLeague

	//Call backend to get all the current leagues for our dropdown
	useEffect(() => {
		const sendRequest = async () => {
			setIsLoading(true)
			try {
				const response = await fetch(
					process.env.REACT_APP_BACKEND_URL + '/admin/leagues/current',
				)

				const responseData = await response.json()

				if (!response.ok) {
					throw new Error(responseData.message)
				}

				setLoadedLeagues(responseData.currentLeagues)
				setLeaguesNoDuplicates(responseData.currentLeaguesSortedNoDuplicates)
				setIsLoading(false)
			} catch (err) {
				setError(err.message)
			}
			setIsLoading(false)
		}
		sendRequest()
	}, [setLoadedLeagues, setLeaguesNoDuplicates])

	let leagueArray, leaguesNoDuplicatesArray

	//
	//
	//
	if (leaguesNoDuplicates && !isLoading) {
		leaguesNoDuplicatesArray = []
		leaguesNoDuplicates.forEach((league) => {
			const leagueDisplay = league.leagueName
			leaguesNoDuplicatesArray.push(leagueDisplay)
		})
	}

	let navigate = useNavigate()

	const handleChange = (e) => {
		if (e.target.value === '*Previous Tournaments*') {
			navigate('/league/previousLeagues')
		} else if (e.target.value !== 'Select League or Tournament....') {
			e.preventDefault()
			const selectedValue = e.target.value
			//console.log(selectedValue)
			selectedLeague = leaguesNoDuplicates[selectedValue]
			const leagueId = selectedLeague._id
			navigate(`/league/schedule/${leagueId}`) //< - - This changes the url
		}
	}

	return (
		<React.Fragment>
			<Card>
				{!isLoading && leaguesNoDuplicates && (
					<form className='form-control-lg'>
						<select
							className='selector my-1 mr-sm-2 selectLeagueDropdown'
							onChange={handleChange}
						>
							<option defaultValue>Select League or Tournament....</option>
							{leaguesNoDuplicatesArray.map((league, i) => (
								<option value={i} key={i}>
									{league}
								</option>
							))}
							<option style={{ background: '#edcb37' }}>
								*Previous Tournaments*
							</option>
						</select>
					</form>
				)}
			</Card>
		</React.Fragment>
	)
}

export default SelectLeagueSchedule
 */
